import { atomWithStorage } from "jotai/utils";

export const nextURLStoreInitialState = { nextURL: undefined };
export const nextURLStoreKey = "bonusxNextURL";

export const nextURLStore = atomWithStorage<{ nextURL?: string }>(nextURLStoreKey, nextURLStoreInitialState);
